export { default as BenefitsBlock } from './BenefitsBlock';
export type { IBenefit } from './BenefitsBlock';
